module.exports = __webpack_public_path__ + "img/BlueAltar.8f8aa564.png";